const breakpoints = {
	// OLD - will be deprecated
	xs: { key: 'xs', width: 0, gutter: 20, columns: 4, margins: 16 },
	// sm AND md are the same now
	sm: { key: 'sm', width: 600, gutter: 20, columns: 8, margins: 32 },
	md: { key: 'md', width: 600, gutter: 20, columns: 8, margins: 32 },
	// Special breakpoint based on md
	s900: { key: 's900', width: 900, gutter: 20, columns: 8, margins: 32 },
	// lg AND xl are the same now
	lg: { key: 'lg', width: 1200, gutter: 24, columns: 12, margins: 120 },
	xl: { key: 'xl', width: 1200, gutter: 24, columns: 12, margins: 120 },
	// gridMax: { width: 1440, gutter: 24, columns: 12, margins: 0 }, // Not used
	xxl: { key: 'xxl', width: 1680, gutter: 24, columns: 12, margins: 0 },

	// NEW
	small: {
		key: 'small',
		width: 0,
		gutter: 8,
		columns: 12,
		margins: 20,
		maxContentWidth: '100%',
		textStyles: 'small',
		isNew: true,
	},
	medium: {
		key: 'medium',
		width: 672,
		gutter: 16,
		columns: 12,
		margins: 32,
		maxContentWidth: '100%',
		textStyles: 'regular',
		isNew: true,
	},
	large: {
		key: 'large',
		width: 808,
		gutter: 24,
		columns: 12,
		margins: 0,
		maxContentWidth: '646px',
		textStyles: 'regular',
		isNew: true,
	},
	extraLarge: {
		key: 'extraLarge',
		width: 1240,
		gutter: 24,
		columns: 12,
		margins: 0,
		maxContentWidth: '1280px',
		textStyles: 'regular',
		isNew: true,
	},
}

export default breakpoints
